import { util } from 'echarts/core';
import { type ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';

const toggleDvMinPercent = series => {
  const { dvMinPercent, data } = series;
  if (!dvMinPercent) {
    return;
  }

  const formatData = (data, total?: number) => {
    const totalNum =
      total || data.reduce((res: number, i) => (i.value >= 0 ? res + i.value : res), 0);
    const min = totalNum * dvMinPercent || 0;
    let newValue = 0;
    const newData = data.map(i => {
      if (i.children) {
        const childrenData = formatData(i.children, totalNum);
        newValue += childrenData.value;
        return {
          ...i,
          originValue: i.value,
          value: childrenData.value,
          children: childrenData.data
        };
      }
      const value = i.value < 0 || i.value < min ? min : i.value;
      newValue += value;
      return {
        ...i,
        originValue: i.value,
        value
      };
    });

    return {
      data: newData,
      value: newValue
    };
  };
  const newData = formatData(data);

  return { ...series, data: newData.data };
};

function parseTreemap(option: Parameters<ThemeParser>[0]) {
  option.series = option.series.map(item => {
    if (item.type !== 'treemap') {
      return item;
    }
    return toggleDvMinPercent(
      util.merge(
        {
          width: '100%',
          height: '100%',
          breadcrumb: { show: false }, // 面包屑
          squareRatio: 1, // 尽量按照该比例进行布局
          nodeClick: false, // 点击事件
          roam: false, // 禁止平移缩放
          itemStyle: {
            gapWidth: 2, // 两个方块之间的间距
            borderColor: 'transparent'
          },
          emphasis: {
            disabled: true // 取消高亮配置
          },
          label: {
            fontSize: 12,
            disance: 4, // 距离图形元素的距离
            lineHeight: 16,
            color: '#fff',
            fontFamily: 'THSJinRongTi-Medium',
            overflow: 'none',
            formatter: data =>
              [`{name|${data.data.name}}`, `{value|${data.data.labelValue}}`].join('\n'),
            rich: {
              value: {
                padding: [2, 0, 0, 0]
              }
            }
          },
          AnimationEasing: 'quinticInOut', // 动画缓动函数
          dvMinPercent: 0.01, // 自定义配置，设置最小比例的图形
          dvLabelType: 'twoLineBasic' // 自定义配置，标签展示类型
        },
        item,
        true
      )
    );
  });
}

/**
 * 移动端主题-矩形树图解析器
 */
export function treemapThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  const series = normalizeToArray(option.series);
  if (series.find(i => i.type === 'treemap')) {
    parseTreemap(option);
  }
}
